export interface AnalyticsEventData {
    name: string;
    action: string;
    element_name: string;
    category: string;
    variant: string;
    data: {
        control: string;
        number: number;
        total: number;
    };
}

/**
 * Service for building and dispatching analytics events
 */
export class AnalyticsService {
    /**
     * Build analytics event for slider control
     * @param direction - Direction of slider ('prev' or 'next')
     * @param currentIndex - Current slide index (1-based for display)
     * @param totalSlides - Total number of slides
     * @param componentName - Name of the component
     * @returns Analytics event data
     */
    static buildSliderEvent(
        direction: 'prev' | 'next',
        currentIndex: number,
        totalSlides: number,
        componentName: string
    ): AnalyticsEventData {
        return {
            name: `${direction}_element_shown`,
            action: `${direction} control clicked or swiped`,
            element_name: componentName.toLowerCase(),
            category: '',
            variant: '',
            data: {
                control: direction,
                number: currentIndex,
                total: totalSlides,
            },
        };
    }

    /**
     * Dispatch custom analytics event
     * @param target - Element to dispatch event from
     * @param eventData - Analytics event data
     */
    static dispatch(target: EventTarget, eventData: AnalyticsEventData): void {
        target.dispatchEvent(
            new CustomEvent('der-analytics', {
                detail: eventData,
                bubbles: true,
                composed: true,
            })
        );
    }
}
